import React from "react";
import styles from "./FeaturedTermSettings.module.scss";
import ListWrapper from "../../../../common/management/ListWrapper";
import { SonicTermData } from "../../../../common/classes/SonicTerm";
import SelectMultipleTerms from "../../../../common/forms/SelectMultipleTerms";
import SaveButton from "../../../../common/nav/SaveButton";
import FeaturedTermSettingsItem from "./FeaturedTermSettingsItem";
import { RequestState } from "../../../../utils/RequestState";
import LoadingSpinner from "../../../../common/LoadingSpinner";
import NotificationModal from "../../../../common/settings-modal/NotificationModal";
import SelenaA from "../../../../assets/img/service/selena-a.webp";
import { TermType } from "../../../../utils/useTerm";

type Props = {
  maximumNumber: number;
  isLoading: boolean;
  requestState: RequestState;
  termName: string;
  featuredTerms: Array<SonicTermData>;
  handleChange: (value: Array<SonicTermData>) => void;
  handleSubmit: () => void;
};
const FeaturedTermSettings: React.FC<Props> = ({
  maximumNumber,
  isLoading,
  requestState,
  termName,
  featuredTerms,
  handleChange,
  handleSubmit,
}) => {
  return (
    <ListWrapper pageTitle={`イチオシ${termName}設定`}>
      {isLoading === true ? (
        <LoadingSpinner space={5} admin_page={true} />
      ) : (
        <div className={styles["featured-term-settings"]}>
          <SelectMultipleTerms
            termType={TermType.Games}
            termName={termName}
            buttonText={`${termName}を設定する`}
            terms={featuredTerms}
            handleTerms={handleChange}
            isAdminPage={true}
            maximumNumber={maximumNumber}
            buttonClass={styles["featured-term-settings__btn"]}
          />
          <ul className={styles["featured-term-settings__list"]}>
            {Array.from({ length: maximumNumber }).map((v, i) => (
              <FeaturedTermSettingsItem
                key={i}
                selectedTerm={featuredTerms[i]}
              />
            ))}
          </ul>
          <SaveButton
            wrapperClass={styles["featured-term-settings__btn"]}
            title={"保存"}
            onClick={() => handleSubmit()}
          />
          {requestState === RequestState.Success ? (
            <NotificationModal
              color={"#27c900"}
              icon_class={["fal", "check-circle"]}
              message={"保存が完了しました"}
              img_src={SelenaA}
            />
          ) : null}
        </div>
      )}
    </ListWrapper>
  );
};

export default FeaturedTermSettings;
